'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _render = require('./render');

var _render2 = _interopRequireDefault(_render);

var _handlers = require('./handlers');

var _handlers2 = _interopRequireDefault(_handlers);

var _fetch = require('./fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _selector = require('./selector');

var _selector2 = _interopRequireDefault(_selector);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $dom = {};
var config = {
  parameters: {},
  observers: []
};

var initHandlers = function initHandlers(gn) {
  Object.keys(_handlers2.default).forEach(function (handler) {
    _handlers2.default[handler]($dom, gn, config);
  });
};

var initBindings = function initBindings() {
  $dom.window = (0, _jquery2.default)(window);
  Object.keys(_constants.DOM_CLASSES).forEach(function (key) {
    $dom[key] = $dom.root.find(_constants.DOM_CLASSES[key]);
  });
};

var onDocumentReady = function onDocumentReady(gn) {
  _render2.default.placeholder(config);
  var dataPromises = {
    user: _fetch2.default.user(),
    sections: config.parameters.sections ? _bluebird2.default.resolve(config.parameters.sections) : _fetch2.default.sections(config.parameters.env),
    product: config.parameters.product ? _bluebird2.default.resolve(config.parameters.product) : _fetch2.default.product()
  };
  return _bluebird2.default.props(dataPromises).then(function (data) {
    config.user = data.user;
    config.parameters.sections = data.sections;
    config.parameters.product = data.product;
    $dom.root = _render2.default.final(config);
    /* Only render the account selector if the user is on Advertise. */
    var renderSelector = config.user.user && config.parameters.product === 'advertise';
    return _selector2.default.init(renderSelector);
  }).then(function () {
    initBindings();
    initHandlers(gn);
  });
};

var globalNav = {
  init: function init(parameters) {
    var _this = this;

    /* Load default configuration options for any parameters that aren't provided in argument config object, then overwrite with supplied params. */
    config.parameters = _extends({}, _constants.CONFIG, config.parameters, parameters);
    return new _bluebird2.default(function (resolve) {
      (0, _jquery2.default)(function () {
        onDocumentReady(_this);
        resolve();
      });
    });
  },
  initPlaceholder: function initPlaceholder(params) {
    _render2.default.placeholder(params);
  },
  toggleFlyout: function toggleFlyout() {
    (0, _jquery2.default)('body').toggleClass(_constants.DOM_CLASSES.bodyNoScroll);
    $dom.mask.toggleClass(_constants.DOM_CLASSES.maskFlyoutOpen);
    $dom.flyout.toggleClass(_constants.DOM_CLASSES.flyoutOpen);
  },
  toggleSearch: function toggleSearch() {
    $dom.nav.toggleClass(_constants.DOM_CLASSES.navSearching);
    if ($dom.nav.hasClass(_constants.DOM_CLASSES.navSearching)) {
      $dom.searchInput.focus();
    }
  },
  showSearch: function showSearch() {
    $dom.nav.addClass(_constants.DOM_CLASSES.navSearching);
    $dom.searchInput.focus();
  },
  hideSearch: function hideSearch() {
    if ($dom.nav.hasClass(_constants.DOM_CLASSES.navSearching)) {
      $dom.nav.removeClass(_constants.DOM_CLASSES.navSearching);
    }
  },
  getSearch: function getSearch() {
    return $dom.searchInput.val();
  },
  initSection: function initSection(section) {
    if (config.parameters.sections && config.parameters.product) {
      if (config.parameters.sections[config.parameters.product].sections[section]) {
        this.init({ section: section });
      } else {
        console.warn('No section \'' + section + '\' exists for product \'' + config.parameters.product + '\'.');
      }
    }
  },
  initProduct: function initProduct(product) {
    if (config.parameters.sections) {
      if (config.parameters.sections[product]) {
        this.init({ product: product });
      } else {
        console.warn('No product \'' + product + '\' exists in current sections object.');
      }
    }
  },
  showAccountSelector: function showAccountSelector() {
    (0, _jquery2.default)('body').addClass(_constants.DOM_CLASSES.bodyNoScroll);
    $dom.accountSelector.addClass(_constants.DOM_CLASSES.accountSelectorOpen);
    $dom.mask.addClass(_constants.DOM_CLASSES.maskAccountSelectorOpen);
  },
  hideAccountSelector: function hideAccountSelector() {
    (0, _jquery2.default)('body').removeClass(_constants.DOM_CLASSES.bodyNoScroll);
    $dom.accountSelector.removeClass(_constants.DOM_CLASSES.accountSelectorOpen);
    $dom.mask.removeClass(_constants.DOM_CLASSES.maskAccountSelectorOpen);
  },
  filterAccounts: function filterAccounts(val) {
    _store2.default.accountsFilter = val;
    _selector2.default.refreshAccountsList();
    $dom.accountSelectorItem = $dom.root.find(_constants.DOM_CLASSES.accountSelectorItem);
    _handlers2.default.selectorAccountsList($dom, this, config);
  },
  addObserver: function addObserver(observer) {
    config.observers.push(observer);
  },
  removeObservers: function removeObservers() {
    config.observers = [];
  },
  setContext: function setContext(newContext, parameters) {
    var _this2 = this;

    /* Ensure that the p-code does not begin with 'p-'. */
    if (newContext) {
      if (newContext.pCode && newContext.pCode.indexOf('p-') === 0 && newContext.pCode.length === 15) {
        newContext.pCode = newContext.pCode.slice(2);
      }
      return _store2.default.setContext(newContext).then(function () {
        _this2.init(parameters || {});
      });
    }
    return this.init(parameters || {});
  },
  setContextParameter: function setContextParameter(key, value) {
    _store2.default.setContextParameter(key, value);
    this.init();
  },
  refreshSection: function refreshSection(_ref) {
    var pCode = _ref.pCode;

    var href = window.location.href;
    var matcher = new RegExp(/(\/|#|=)p-(.{13})/g);
    var oldPCode = matcher.exec(href);
    if (oldPCode && href) {
      window.location = href.replace(oldPCode[2], pCode);
    }
  },
  getContext: function getContext() {
    return _store2.default.getContext();
  },
  getAccounts: function getAccounts() {
    return _store2.default.getAccounts();
  },
  getCurrentUser: function getCurrentUser() {
    return config.user;
  }
};

module.exports = globalNav;


//////////////////
// WEBPACK FOOTER
// ./node_modules/qc-global-navigation/src/index.js
// module id = 96
// module chunks = 0